import {useHttp} from "../../../context/HttpProvider";
import {useEffect, useState} from "react";
import MapEntity from "./MapEntity";
import { ContinueAction } from "../ReportWizardProvider";
import useValueMapping from "../mapping/hooks/useValueMapping";

export default function ManufacturerMapper() {
    const {mappingApi} = useHttp();
    const [hasLoaded, setHasLoaded] = useState(false);
    const [reportUploadId, mappingData, setMappingData, updateMapping, validate, validationLookup] = useValueMapping(ContinueAction.SaveManufacturerMappings);

    async function getManufacturerMappings() {
        var response = await mappingApi.getManufacturerMappings(reportUploadId);
        if(response) {
            setMappingData(response);
            setHasLoaded(true);
            validate(response);
        }
    }

    useEffect(() => {
        if(mappingApi != null) {
            getManufacturerMappings();
        }
    }, [mappingApi])

    return <>
        {hasLoaded && <MapEntity data={mappingData} type="Manufacturer" updateMapping={updateMapping} validationLookup={validationLookup} />}
    </>
}